import { InlineText1 as Text } from '@cian/ui-kit';

import { FC } from 'react';

import { IAddress } from './types';

export const Address: FC<IAddress> = props => {
  const { addressText, className } = props;

  return (
    <div className={className}>
      <Text>{addressText}</Text>
    </div>
  );
};

Address.displayName = 'Address';
